<template>
  <a-card :bordered="false">
    <div class="banner_container gggl">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="公告标题">
                <a-input
                  placeholder="请输入公告标题"
                  v-decorator="['title']"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="关联产品">
                <a-select
                  mode="multiple"
                  show-search
                  placeholder="请选择关联产品"
                  :showSearch="true"
                  optionFilterProp="label"
                  v-decorator="['fundCodes']"
                  style="overflow: hidden"
                >
                  <a-select-option
                    v-for="item in fundListArr"
                    :key="item.fundCode"
                    :label="item.fundCodeName"
                  >
                    {{ item.fundCodeName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="发布状态">
                  <a-select
                    placeholder="请选择发布状态"
                    v-decorator="['status']"
                  >
                    <a-select-option value="1"> 待发布 </a-select-option>
                    <a-select-option value="0"> 已发布 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="审核状态">
                  <a-select
                    placeholder="请选择审核状态"
                    v-decorator="['isReview']"
                  >
                    <a-select-option value="0"> 待审核 </a-select-option>
                    <a-select-option value="1"> 审核通过 </a-select-option>
                    <a-select-option value="2"> 审核驳回 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="是否仅持有人可见">
                  <!-- 0-全部人可见 1-开户人可见 2-持有人可见 -->
                  <a-select
                    placeholder="请选择"
                    v-decorator="['permissionType']"
                  >
                    <a-select-option value="0"> 全部人可见 </a-select-option>
                    <a-select-option value="1"> 开户人可见 </a-select-option>
                    <a-select-option value="2"> 持有人可见 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd()" type="primary" icon="plus"
          >新增</a-button
        >
        <a-button @click="handleUpoadBatch()" icon="upload">批量上传</a-button>
        <a-button @click="handleUpoadLog()" icon="unordered-list"
          >批量导入日志</a-button
        >
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="puDetele(selectedRowKeys)"
              ><a-icon type="delete" />批量删除</a-menu-item
            >
            <a-menu-item key="2" @click="batchPublish(1)"
              ><a-icon type="arrow-up" />批量发布</a-menu-item
            >
            <a-menu-item key="3" @click="batchPublish(0)"
              ><a-icon type="arrow-down" />批量下架</a-menu-item
            >
            <a-menu-item key="4" @click="batchReview()"
              ><a-icon type="check" />批量审核</a-menu-item
            >
          </a-menu>
          <a-button> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- 清空 -->
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <!-- 表格 -->
      <a-table
        ref="tableSelect"
        :columns="columns"
        rowKey="id"
        bordered
        :scroll="{ x: 1200 }"
        :loading="loading"
        :data-source="dataSource"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="pic" slot-scope="text, record">
          <img :src="record.pic" alt="" style="width: 80px; height: 40px" />
        </template>
        <template slot="publishFlag" slot-scope="text">
          <span v-if="text == 0">待发布</span>
          <span v-if="text == 1">已发布</span>
        </template>
        <template slot="publish" slot-scope="text, record">
          <a-switch
            v-model="record.statusFlg"
            checked-children="已发布"
            un-checked-children="未发布"
            :disabled="
              record.isReview == 1 && record.status != 2 ? false : true
            "
            @click="(checked) => handlePublishNotice(checked, record)"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="handleEdit(record, record.id)">编辑</a>
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            :disabled="
              record.status != 2 &&
              record.isReview == 1 &&
              record.statusFlg == 1
                ? true
                : false
            "
            @click="onDelete(record.id)"
            >删除</a
          >
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            :disabled="
              (record.isReview == 0 || record.isReview == 2) &&
              record.status != 2
                ? false
                : true
            "
            @click="singleExamine(record)"
            >审核</a
          >
          <a-divider type="vertical" />
          <a href="javascript:;" @click="reviewModal(record)">预览</a>
        </template>
      </a-table>

      <notice-manage-modal
        :columnChannel="columnChannel"
        :fundList="fundList"
        ref="modalForm"
        @ok="modalFormOk"
      ></notice-manage-modal>
      <a-modal
        title="审核"
        :visible="showExamine"
        :width="800"
        @cancel="examineCancel"
        @ok="handalExamine"
      >
        <a-radio-group v-model="examineFlg" @change="examineFlgChange">
          <a-radio :value="1">审核通过</a-radio>
          <a-radio :value="2">审核驳回</a-radio>
        </a-radio-group>
        <a-textarea
          style="margin-top: 20px"
          placeholder="请输入理由"
          v-model="reason"
          :auto-size="{ minRows: 2, maxRows: 6 }"
        />
      </a-modal>
      <Preview ref="previewModal" :type="'4'" />
      <importModal ref="importsModal" />
      <importLog ref="importsLogModal" />
    </div>
  </a-card>
</template>

<script>
import { setColumnDeleteBatch, queryReviewedAll } from '@/api/api';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import noticeManageModal from './modules/noticeManageModal';
import { getAction, postAction, postTag } from '@/api/manage';
import Preview from '@/components/common/Preview';
import importModal from './modules/importModal';
import importLog from './modules/importLog';

const columns = [
  {
    align: 'center',
    title: '公告标题',
    dataIndex: 'title',
    key: 'title',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '上架渠道栏目',
    dataIndex: 'channelColumnList',
    ellipsis: true,
    width: 200,
    customRender: (text) => {
      if (!text) {
        return '--';
      }
      let str = [];
      text.forEach((item) => {
        str.push(item.columnName);
      });
      return str.length > 0 ? str.join(',') : '--';
    },
  },
  {
    align: 'center',
    title: '关联产品',
    dataIndex: 'fundList',
    ellipsis: true,
    width: 200,
    customRender: (text) => {
      if (!text) {
        return '--';
      }
      let str = [];
      text.forEach((item) => {
        str.push(item.fundName);
      });
      return str.length > 0 ? str.join(',') : '--';
    },
  },

  {
    align: 'center',
    title: '审核状态',
    dataIndex: 'isReview',
    customRender: (text) => {
      return text == 0 ? '待审核' : text == 1 ? '审核通过' : '审核驳回';
    },
    width: 200,
  },
  {
    align: 'center',
    title: '理由',
    dataIndex: 'reason',
    ellipsis: true,
    customRender: (text) => {
      return !text || text == '' ? '--' : text;
    },
    width: 200,
  },
  {
    align: 'center',
    title: '发布时间',
    dataIndex: 'publishTime',

    width: 200,
  },
  {
    align: 'center',
    title: '发布状态',
    dataIndex: 'status',
    scopedSlots: {
      customRender: 'publishFlag',
    },
    width: 200,
  },
  {
    align: 'center',
    title: '是否失效',
    dataIndex: 'isExpire',
    customRender: (text) => {
      return text == true ? '已失效' : '未失效';
    },
    width: 200,
  },
  {
    align: 'center',
    title: '是否发布',
    dataIndex: 'publish',
    scopedSlots: {
      customRender: 'publish',
    },
    width: 150,
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    fixed: 'right',
    scopedSlots: {
      customRender: 'operation',
    },
  },
];
export default {
  mixins: [mixinDevice, JeecgListMixin],
  components: {
    noticeManageModal,
    Preview,
    importModal,
    importLog,
  },
  data() {
    return {
      dataSource: [],
      fundListArr: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns,
      routerFundCode: '',
      form: this.$form.createForm(this, {
        name: 'advanced_search',
      }),
      selectedRowKeys: [],
      loading: false,
      columnChannel: [],
      queryColumnChannel: [],
      fundList: {},
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/content/notice/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/content/notice/del',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/notice/delBatch',
        publishNotice: process.env.VUE_APP_CMS_CONTENT + '/content/notice/put',
        reviewNotice:
          process.env.VUE_APP_CMS_CONTENT + '/content/notice/review',
        publishBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/notice/put/batch',
        reviewBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/notice/reviewBatch',
      },
      showExamine: false, //审核弹窗
      examineFlg: 1, //1-审核通过 2-审核拒绝
      reason: '', //审核拒绝理由
      toggleSearchStatus: false,
      isSingleReview: true,
      currentExamine: {}, //当前要审核的数据
    };
  },
  created() {
    this.initData();
    this.loadData();
    this.getFundList();
  },
  methods: {
    searchReset() {
      this.form.resetFields();
      this.loadData(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中

      this.ipagination = pagination;
      this.loadData();
    },

    //获取关联产品
    getFundList() {
      queryReviewedAll().then((res) => {
        if (res.success) {
          res.result.map((item) => {
            item.fundCodeName = item.fundName + '/' + item.fundCode;
          });
          this.fundListArr = res.result;
        }
      });
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    //批量下架
    batchPublish(type) {
      let content = type == 1 ? '发布' : '下架';
      let ids = this.selectedRowKeys.join(',');

      let that = this;
      this.$confirm({
        title: '确认',
        content: `确定要批量${content}吗?`,
        onOk: () => {
          postAction(that.url.publishBatch, { ids: ids, status: type }).then(
            (res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
                that.onClearSelected();
              } else {
                that.$message.error(res.message);
              }
            }
          );
        },
      });
    },
    puDetele(ids) {
      this.$confirm({
        title: '确认',
        content: '确定要批量删除吗?',
        onOk: () => {
          setColumnDeleteBatch({
            ids: ids.join(','),
          }).then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.loadData(1);
            } else {
              this.$message.error(res.message);
            }
          });
        },
      });
    },

    loadData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      // this.routerFundCode = this.$route.params.fundCode;
      // var params = this.getQueryParams(); //查询条件
      // if (this.routerFundCode) {
      //   params.fundCode = this.routerFundCode;
      // }

      let params = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        // title: this.queryParam.title
      };
      this.form.validateFields((err, values) => {
        if (!err) {
          params = Object.assign(params, values);
        }
      });
      this.loading = true;
      postTag(this.url.list, params).then((res) => {
        if (res.success) {
          this.loading = false;

          this.dataSource =
            res.result && res.result.records ? res.result.records : [];
          this.dataSource.forEach((item) => {
            item.statusFlg = item.status == 0 ? false : true;
          });

          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    initData() {
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
        { channelCode: 'pc_service' }
      ).then((res) => {
        if (res.success) {
          this.columnChannel = res.result;
          this.queryColumnChannel = JSON.parse(JSON.stringify(res.result));
          this.handleColumnValue(this.queryColumnChannel);
        }
      });
    },
    handleColumnValue(queryColumnChannel) {
      for (let index in queryColumnChannel) {
        let item = queryColumnChannel[index];
        item.value = item.code;
        if (item.children && item.children.length > 0) {
          this.handleColumnValue(item.children);
        }
      }
    },
    // 删除
    onDelete(id) {
      let that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    handlePublishNotice(checked, record) {
      postAction(this.url.publishNotice, {
        id: record.id,
        status: checked ? 1 : 0,
      }).then((res) => {
        if (res.success) {
          this.loadData(1);
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //批量审核
    batchReview() {
      this.showExamine = true;
      this.isSingleReview = false;
    },
    //单个审核
    singleExamine(record) {
      this.showExamine = true;
      this.currentExamine = record;
    },
    examineFlgChange(e) {
      this.examineFlg = e.target.value;
    },
    examineCancel() {
      this.showExamine = false;
      this.reason = '';
    },

    handalExamine() {
      if (this.examineFlg == '') {
        this.$message.warning('请选你要审核的状态');
      }
      if (this.isSingleReview) {
        postAction(this.url.reviewNotice, {
          id: this.currentExamine.id,
          review: this.examineFlg,
          reason: this.reason,
        })
          .then((res) => {
            if (res.success) {
              this.showExamine = false;
              this.loadData(1);
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          })
          .finally(() => {
            this.showExamine = false;
            this.reason = '';
          });
      } else {
        let ids = this.selectedRowKeys.join(',');
        postAction(this.url.reviewBatch, {
          ids: ids,
          review: this.examineFlg,
          reason: this.reason,
        })
          .then((res) => {
            if (res.success) {
              this.showExamine = false;
              this.onClearSelected();
              this.loadData(1);
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          })
          .finally(() => {
            this.showExamine = false;
            this.reason = '';
          });
      }
    },
    reviewModal(record) {
      if (record) {
        this.$refs.previewModal.dataSource = record.channelColumnList;
      }
      this.$refs.previewModal.visible = true;
    },
    handleUpoadBatch() {
      this.$refs.importsModal.handleVisible();
    },
    handleUpoadLog() {
      this.$refs.importsLogModal.handleVisible();
    },
  },
};
</script>

<style scoped lang="less">
.table-operator {
  margin-bottom: 8px;
  .ant-btn {
    margin: 0 8px 8px 0;
  }
}
.table-page-search-submitButtons {
  float: left;
}
.banner_container {
  background: #fff;

  .lm {
    z-index: 999;
  }

  .banner_title {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    font-size: 22px;
    color: #333;
    margin-bottom: 20px;
  }

  .banner_btns {
    margin-bottom: 20px;

    .ant-btn {
      margin-right: 10px;
    }
  }

  .ant-table-wrapper {
    margin-bottom: 30px;
  }

  .bannerImg {
    display: flex;

    .img_item {
      width: 250px;
      height: 170px;

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .tips {
    color: rgba(144, 147, 153, 1);
    font-size: 12px;
  }
}
</style>
<style lang="less">
.gggl {
  .ant-select-open .ant-select-selection,
  .lm .ant-select-selection--multiple {
    max-height: 104px;
    overflow-y: scroll;
  }
}
.edit-upload {
  margin-left: 136px;
  margin-bottom: 23px;

  .pdf {
    color: #999;
    margin-left: 10px;
  }
}
/deep/.ant-table-tbody {
  overflow-y: hidden;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px;
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /**滚动条的滑块*/
    border-radius: 5px;
    background: rgba(100, 177, 240, 0.5);
  }
  &::-webkit-scrollbar-track {
    /**滚动条的轨道*/
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
